import servicesJSON from "../../inc/services.json";

export function formatLabel(value) {
  if (!value) return "—";

  return String(value)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getServiceOption(serviceCode) {
  const code = String(serviceCode || "").trim();
  if (!code) return null;
  return (servicesJSON?.jobs || []).find((service) => String(service.code || "") === code) || null;
}

export function getServiceLabel(serviceCode) {
  const service = getServiceOption(serviceCode);
  return service?.label || formatLabel(serviceCode);
}

export function getServiceLevelOption(serviceCode, levelCode) {
  const service = getServiceOption(serviceCode);
  const code = String(levelCode || "").trim();
  if (!service || !code) return null;
  return (service.levels || []).find((level) => String(level.code || "") === code) || null;
}

export function getServiceLevelLabel(serviceCode, levelCode) {
  const level = getServiceLevelOption(serviceCode, levelCode);
  return level?.label || formatLabel(levelCode);
}

export function formatServiceLevelSummary(serviceCode, levelCode) {
  const serviceLabel = getServiceLabel(serviceCode);
  const levelLabel = getServiceLevelLabel(serviceCode, levelCode);
  if (serviceLabel === "—" && levelLabel === "—") return "—";
  if (serviceLabel === "—") return levelLabel;
  if (levelLabel === "—") return serviceLabel;
  return `${serviceLabel} · ${levelLabel}`;
}
